import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaPython,
  FaReact,
  FaDocker,
  FaGithub,
  FaGitlab,
  FaJenkins,
  FaAws
} from "react-icons/fa";

import {
  SiDotnet,
  SiRabbitmq,
  SiOpentelemetry,
  SiGrafana,
  SiMysql,
  SiMariadb,
  SiTypescript,
  SiOpensearch
} from "react-icons/si";

export const TECHNICAL_SKILLS = {

  "Programming & Frameworks": [
    {
      label: <FaPython className="project-icon" size={32} />,
      toolTip: "Python"
    },
    {
      label: <SiDotnet className="project-icon" size={32} />,
      toolTip: "C# / .NET"
    },
    {
      label: <FaJs className="project-icon" size={32} />,
      toolTip: "JavaScript"
    },
    {
      label: <SiTypescript className="project-icon" size={32} />,
      toolTip: "TypeScript"
    },
    {
      label: <FaReact className="project-icon" size={32} />,
      toolTip: "React"
    }
  ],

  "Databases": [
    {
      label: <SiMysql className="project-icon" size={32} />,
      toolTip: "MySQL"
    },
    {
      label: <SiMariadb className="project-icon" size={32} />,
      toolTip: "MariaDB"
    }
  ],

  "Distributed Systems & Observability": [
    {
      label: <SiRabbitmq className="project-icon" size={32} />,
      toolTip: "RabbitMQ"
    },
    {
      label: <SiOpentelemetry className="project-icon" size={32} />,
      toolTip: "OpenTelemetry"
    },
    {
      label: <SiOpensearch className="project-icon" size={32} />,
      toolTip: "OpenSearch"
    },
    {
      label: <SiGrafana className="project-icon" size={32} />,
      toolTip: "Grafana"
    }
  ],

  "Cloud & Serverless": [
    {
      label: <FaAws className="project-icon" size={32} />,
      toolTip: "AWS (Lambda, CloudWatch, WAF)"
    }
  ],

  "DevOps & Automation": [
    {
      label: <FaDocker className="project-icon" size={32} />,
      toolTip: "Docker"
    },
    {
      label: <FaJenkins className="project-icon" size={32} />,
      toolTip: "Jenkins"
    }
  ],

  "Version Control": [
    {
      label: <FaGithub className="project-icon" size={32} />,
      toolTip: "GitHub"
    },
    {
      label: <FaGitlab className="project-icon" size={32} />,
      toolTip: "GitLab"
    }
  ],

  "Markup & Frontend": [
    {
      label: <FaHtml5 className="project-icon" size={32} />,
      toolTip: "HTML"
    },
    {
      label: <FaCss3Alt className="project-icon" size={32} />,
      toolTip: "CSS"
    }
  ]
};